// Imports for external libraries go here.
import { FC, useEffect } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { baseVariables } from '@marriott/mi-ui-library';
import { useMediaQuery } from '../../../hooks';
import { useMediaQueryStore } from '../../../store';
import { NavigationDropdownProps } from './NavigationDropdown.types';
import NavigationDropdownDesktop from './NavigationDropdownDesktop/NavigationDropdownDesktop';
import NavigationDropdownMobile from './NavigationDropdownMobile/NavigationDropdownMobile';

// Use named rather than default exports.
export const NavigationDropdown: FC<NavigationDropdownProps> = props => {
  const { isDesktop, setIsDesktop } = useMediaQueryStore();
  const matchesDesktop = useMediaQuery(baseVariables.mediaQuery.lg);

  useEffect(() => {
    if (matchesDesktop !== null) {
      setIsDesktop(matchesDesktop);
    }
  }, [matchesDesktop, setIsDesktop]);

  return <>{isDesktop ? <NavigationDropdownDesktop {...props} /> : <NavigationDropdownMobile {...props} />}</>;
};
